import { createRef } from "react";
import ProcedureBlock from "../../../../base/basicComponents/procedureBlock";
import FileSectionBase from "../../../commonComponents/fileBase";
import createProcedureTableData from "../../procedureFileSections/createProcedureTableData";
import NormalModal, { ModalWithScroll } from "../../../../base/basicComponents/modal";
import { timeOutMins } from "../../../../base/basicComponents/modal/controlPageBehavior";
import ProcedureDetailService from "../../../../service/procedureFile/ProcedureDetailService";
import "../../../pages/procedureDetail/createProcedureDetail/style/index.scss";
import {
  detailTableSortFile,
  fileTags,
  getTimeZoneString,
  handleAlertUploadFileError,
  handleUploadErrorCode,
  pageStatus,
  proposedChangeTags,
} from "../../../publicDictionaryValues";
import UpdateSupportingFileManagement from "../fields/supportingFileManagement/updateSupportingFileManagement";
import BaseSupportingFileManagement from "../fields/supportingFileManagement/baseSupportingFileManagement";
import { getPendingAction } from "../../../../store/actions/procedureDetailPageActions";
import { PendingActionTypes } from "../../../../store/actions/constants";
import { checkLatestProcedureInfo } from "../../../pages/procedureDetail/utils";
import { debounce } from "lodash-es";
import { HeaderWithReminder } from "app/pages/procedureDetail/createProcedureDetail/utils";

const ref = createRef();
const supportingFileRef = createRef();
const supportingModalRef = createRef();
const supportingFileTableRef = createRef();
const supportingFileModalTableRef = createRef();

export default class SupportingFileSection extends FileSectionBase {
  constructor(props: any) {
    super(props);
    this.state = {
      supportingSubmited: false,
      supportingSaved: false,
      initSupportingDataList: [],
      isModalOpen: false,
      modalChildContent: "",
      modalOkText: "Confirm",
      modalCancelText: "Cancel",
      isScrollModalOpen: false,
      scrollModalContent: "",
      scrollModalTitle: "",
      handleModalConfirm: () => {
        //there is a empty function
      },
      handleModalCancel: () => {
        //there is a empty function
      },
      isSupportingFileEditToolTipOpen: false,
      supportingFileStepId: null,
      status: 0,
      isMount: false,
      supportingPendingProcessId: null,
    };
    // @ts-ignore
    this.replaceList = [];
    // @ts-ignore
    this.fileList = [];
  }

  /**
   * get files
   * @returns
   */
  getFileList = () => {
    // @ts-ignore
    return this.fileList;
  };

  /**
   * control upload file loading
   * @param {*} type
   */
  // @ts-ignore
  handleUploadLoading = (type: any) => {
    this.props.handleUploadLoading();
  };

  /**
   * update upload file loading number
   */
  setUploadFileNum = () => {
    this.props.setUploadFileNum();
  };

  /**
   * set total file number
   */
  setFileNum = () => {
    this.props.setFileNum();
  };

  /**
   * success callback for click save as draft button
   * @param {*} result
   */
  _supportingSaveSuccess = (result: any) => {
    this.setState({
      supportingSaved: true,
      supportingFileStepId: result.supportingFileStepId,
    });
    this.props.setIsSupportingFileModalChange();
    this.props.saveSuccess(result);
    this._alertSuccess("Save Successful");
    this.handleResetLock("SupportingFile");
  };

  /**
   * function about click save as draft button in supporting file modal
   * @param {*} ref
   */
  supportingFileOnSave = (ref: any) => {
    this.props.showLoading();
    let datalist = JSON.parse(JSON.stringify(ref.current.getDataList()));
    let lastSavedDataList = ref.current.getInitOrLastSaveData();
    datalist = this.checkUpdateDatalist(datalist, lastSavedDataList);
    let deleteList = ref.current.getDeleteList();
    let combineDatalist = datalist.concat(deleteList);
    let convertDataList = this.ConvertToBack(combineDatalist);

    // @ts-ignore
    ProcedureDetailService.saveSupprotingFileAsDraft(
      convertDataList,
      (response: any) => this._supportingSaveSuccess(response, ref),
      this._saveError
    );
  };

  findDataListDataItem = (name: any, DataItem: any) => {
    return DataItem.data.find((item: any) => item.name === name) === null ||
      DataItem.data.find((item: any) => item.name === name) === undefined
      ? ""
      : DataItem.data.find((item: any) => item.name === name).value;
  };

  getNewUpdateDataList = (datalist: any) => {
    const newDataList: any[] = [];
    datalist.forEach((item: any) => {
      const tagValue = item.data.find((item: any) => item.name === "fileName").tagValue;
      const proposedChangeValue = this.findDataListDataItem("proposedChange", item);
      const replaceUserId = this.findDataListDataItem("replaceUserId", item);
      const replaceUserName = this.findDataListDataItem("replaceUserName", item);
      const uploadByValue =
        replaceUserId && replaceUserName
          ? replaceUserId
          : this.findDataListDataItem("uploadBy", item);
      newDataList.push({
        fileOperate: 1,
        fileId: this.findDataListDataItem("fileId", item),
        fileKey: this.findDataListDataItem("fileKey", item),
        fileName: this.findDataListDataItem("fileName", item),
        uploadBy: uploadByValue,
        note: this.findDataListDataItem("note", item),
        proposeChangeTagID: proposedChangeValue,
        fileTagID: tagValue,
        approvedDate:
          proposedChangeValue === null || proposedChangeValue === ""
            ? item.data.find((item: any) => item.name === "approveTime").value
            : null,
      });
    });
    return newDataList;
  };

  ConvertToBack = (datalist: any) => {
    let newDataList = this.getNewDataList(datalist);
    return {
      procedureId: this.props.procedureId,
      procedureTaskId: this.props.procedureTaskId,
      supportingFileStepId: this.state.supportingFileStepId,
      fileList: newDataList,
    };
  };

  UpdateCovertToBack = (datalist: any) => {
    let newDataList = this.getNewUpdateDataList(datalist);
    return {
      procedureId: this.props.procedureId,
      procedureTaskId: this.props.procedureTaskId,
      supportingFileStepId: this.state.supportingFileStepId,
      fileList: newDataList,
    };
  };

  /**
   * success callback for submit
   * @param {*} result
   */
  _supportingSubmitSuccess = (result: any) => {
    this.setState({
      supportingSubmited: true,
    });
    this.props.setIsSupportingFileModalChange();
    this.props.submitSuccess(result);
    this._alertSuccess("Submit Successful");
    this.handleResetLock("SupportingFile");
  };

  /**
   * close modal
   */
  hideAllModal = () => {
    this.setState({
      isModalOpen: false,
      modalChildContent: "",
      handleModalConfirm: () => {
        //there is a empty function
      },
      handleModalCancel: () => {
        //there is a empty function
      },
    });
  };

  /**
   * function about click confirm in submit modal
   * @param {*} ref
   */
  handleSubmitSupportingModalConfirm = debounce(
    (ref) => {
      this.hideAllModal();
      this.props.showLoading();
      let datalist = JSON.parse(JSON.stringify(ref.current.getDataList()));
      let lastSavedDataList = ref.current.getInitOrLastSaveData();
      datalist = this.checkUpdateDatalist(datalist, lastSavedDataList);
      let deleteList = ref.current.getDeleteList();
      let combineDatalist = datalist.concat(deleteList);
      if (this.state.status === 3) {
        // @ts-ignore
        let convertDataList = this.UpdateCovertToBack(combineDatalist, true, ref);
        // @ts-ignore
        ProcedureDetailService.updateSupprotingFileForApproval(
          convertDataList,
          (response: any) => this._supportingSubmitSuccess(response, ref),
          this._submitError
        );
      } else {
        // @ts-ignore
        let convertDataList = this.ConvertToBack(combineDatalist, true, ref);
        // @ts-ignore
        ProcedureDetailService.submitSupprotingFileForApproval(
          convertDataList,
          (response: any) => this._supportingSubmitSuccess(response, ref),
          this._submitError
        );
      }
    },
    1000,
    { leading: true, trailing: false }
  );

  /**
   * error callback for submit check
   * @param {*} error
   */
  handleSupportingFileSubmitCheckError = (error: any) => {
    console.log(error);
    this._alertError("Check Failed!");
    this.props.hideLoading();
  };

  /**
   * success callback for submit check
   * @param {*} response
   * @param {*} ref
   */
  handleSupportingFileSubmitCheckSuccess = (response: any, ref: any) => {
    this.props.hideLoading();
    if (response.result) {
      this.setState({
        isModalOpen: true,
        modalOkText: "Confirm",
        modalCancelText: "Cancel",
        modalChildContent: "Are you sure to submit?",
        handleModalConfirm: () => this.handleSubmitSupportingModalConfirm(ref),
        handleModalCancel: () => {
          //there is a empty function
        },
      });
    } else {
      switch (response.messageCode) {
        case 21:
          this._alertError(
            "You cannot submit Create New Supporting File process while there is a Sharing Relationship approval in progress. Please save all as draft and try again later."
          );
          break;
        case 22:
          this._alertError(
            "You cannot submit Update Supporting File process while there is a Sharing Relationship approval in progress."
          );
          break;
        default:
          break;
      }
    }
  };

  /**
   * check whether there is a share task pending approval when click submit for approval button.
   * @param {*} ref
   */
  handleSubmitSupportingCheck = (ref: any) => {
    const param = {
      procedureId: this.props.procedureId,
      procedureTaskId: this.props.procedureTaskId,
    };
    if (this.state.status === 3) {
      ProcedureDetailService.supportingFileUpdateCheck(
        param,
        (response: any) => this.handleSupportingFileSubmitCheckSuccess(response, ref),
        this.handleSupportingFileSubmitCheckError
      );
    } else {
      ProcedureDetailService.supportingFileSubmitCheck(
        param,
        (response: any) => this.handleSupportingFileSubmitCheckSuccess(response, ref),
        this.handleSupportingFileSubmitCheckError
      );
    }
  };

  /**
   * function about click submit for approval in supporting file edit modal
   * @param {*} ref
   */
  supportingFileOnSubmit = async (ref: any) => {
    this.props.showLoading();
    const shouldContinue = await checkLatestProcedureInfo({
      actionType: PendingActionTypes.SupportingFilesEdit,
      procedureTaskId: this.props.procedureTaskId,
      callbackType: "ONLY_MESSAGE",
    });
    if (!shouldContinue) {
      this.props.hideLoading();
      return;
    }

    if (ref.current !== null) {
      const dataList: any[] = ref.current.getDataList();
      if (dataList.length === 0) {
        ref.current.setFileTableStatus("error");
      } else {
        this.hideModal();
        this.handleSubmitSupportingCheck(ref);
      }
    }
  };

  /**
   * function about click confirm button in cancel modal
   * @param {*} ref
   */
  handleCancelSupportingModalConfirm = (ref: any) => {
    this.hideModal();
    this.hideScrollModal();
    const dataList = JSON.parse(JSON.stringify(ref.current.getInitOrLastSaveData()));
    ref.current.updateDataList(dataList);
    ref.current.cancelDeleteData();
    this.handleResetLockWithoutRefresh("SupportingFile");
    this.props.setActionType(null);
  };

  /**
   * function about click cancel button in supporting file edit modal
   * @param {*} ref
   */
  supportingFileOnCancel = (ref: any) => {
    this.setState({
      isModalOpen: true,
      modalOkText: "Confirm",
      modalCancelText: "Cancel",
      modalChildContent: "Are you sure to quit without saving?",
      handleModalConfirm: () => this.handleCancelSupportingModalConfirm(ref),
      handleModalCancel: () => {
        //there is a empty function
      },
    });
  };

  createSupporting = (createFilesRef: any, response: any, customStatus: any, openModal: any) => {
    const newFiles = detailTableSortFile(response.supportingFiles, this._formateDate);
    let dataList;
    const isModal = createFilesRef === "modal";
    const filesRef = isModal ? null : createFilesRef;

    if (customStatus === 3) {
      dataList = createProcedureTableData.createUpdateSupportingData(newFiles, filesRef);
    } else {
      dataList = createProcedureTableData.createSupportingData(newFiles, filesRef);
    }

    this.setState(
      {
        initSupportingDataList: JSON.parse(JSON.stringify(dataList)),
        supportingFileStepId: response.supportingFileStepId,
      },
      () => openModal && openModal()
    );
    this.props.hideLoading();
  };

  /**
   * create files after get files
   * @param {*} createFilesRef
   */
  // @ts-ignore
  createFiles = (createFilesRef = ref, openModal: any) => {
    this.props.showLoading();
    const procedureId = this.props.procedureId;
    const procedureTaskId = this.props.procedureTaskId;
    ProcedureDetailService.getSupportingFileSection(
      { procedureId: procedureId, procedureTaskId: procedureTaskId },
      (response: any) => {
        let customStatus = 0;
        switch (response.processStatusID) {
          case pageStatus.draft:
            customStatus = 1;
            break;
          case pageStatus.pendingApproval:
            customStatus = 2;
            break;
          case pageStatus.active:
            customStatus = 3;
            break;
          case pageStatus.archived:
            customStatus = 4;
            break;
          default:
            break;
        }
        this.setState(
          {
            status: customStatus,
            supportingPendingProcessId: response.pendingProcessId,
            isMount: true,
          },
          () => this.createSupporting(createFilesRef, response, customStatus, openModal)
        );
      },
      (error: any) => {
        console.log(error);
        // this._alertError("Get supporting files error!");
      }
    );
  };

  /**
   * success callback for click edit check
   * @param {*} response
   */
  checkSupportingFileEditOnSuccess = (response: any) => {
    this.props.hideLoading();
    if (response.result) {
      const para = {
        procedureId: this.props.procedureId,
        procedureSectionType: this.props.actionType,
        timeOutMins: timeOutMins,
      };
      ProcedureDetailService.checkSectionLock(
        para,
        (response: any) =>
          this.checkSupportingFileWhetherLock(response.data.isLocked, response.data.lockUser),
        (response: any) => console.log(response.message)
      );
    } else {
      switch (response.messageCode) {
        case 11:
          this.props.setLock("This section is pending approval.");
          this.handleSupportingFileLock();
          break;
        case 4:
          this.props.setLock("Sharing Relationship Process is pending approval.");
          this.handleSupportingFileLock();
          break;
        case 2:
          this.props.setLock("Please assign a Primary Procedure Owner first.");
          this.handleSupportingFileLock();
          break;
        default:
          break;
      }
    }
  };

  /**
   * error callback for click edit check
   * @param {*} error
   */
  checkSupportingFileEditOnError = (error: any) => {
    console.log(error);
    this.props.hideLoading();
    // this._alertError("Check Supporting Files Section Edit Error!");
  };

  /**
   * function about click edit icon in supporting file section
   */
  handleSupportingFileEditClick = async () => {
    this.props.showLoading();
    await checkLatestProcedureInfo({
      actionType: PendingActionTypes.SupportingFilesEdit,
      procedureTaskId: this.props.procedureTaskId,
    });

    const param = {
      procedureAccountId: this.props.procedureAccountId,
      procedureId: this.props.procedureId,
      procedureTaskId: this.props.procedureTaskId,
    };
    ProcedureDetailService.checkSupportingFileEdit(
      param,
      this.checkSupportingFileEditOnSuccess,
      this.checkSupportingFileEditOnError
    );
  };

  componentDidUpdate() {
    const pendingAction = getPendingAction();
    if (pendingAction === PendingActionTypes.SupportingFilesEdit && this.props.procedureAccountId) {
      this.handleSupportingFileEditClick();
    }
  }

  /**
   * control tooltip open
   * @param {*} isOpen
   */
  setScrollModalOpen = (isOpen: any) => {
    this.setState({
      isSupportingFileEditToolTipOpen: isOpen,
    });
  };

  /**
   * manatory check
   * @param {*} ref
   */
  procedureMandatoryCheck = (ref: any) => {
    let datalist = ref.current.getDataList();
    if (datalist.length === 0) {
      ref.current.setFileTableStatus("error");
    }
  };

  /**
   * function about edit check callback lock
   */
  handleSupportingFileLock = () => {
    this.setScrollModalOpen(true);
  };

  handleReturnModalSupportingFileTable = (isShowDeleteBtn: any, isShowShareBtn: any) => {
    return this.handleReturnSupportingFileTable({
      supportingSubmited: this.state.supportingSubmited,
      supportingSaved: this.state.supportingSaved,
      isShowUploadBtn: true,
      isShowDownloadBtn: true,
      isShowDeleteBtn: isShowDeleteBtn,
      isShowShareBtn: isShowShareBtn,
      isShowActionBtns: true,
      isShowSupportingFileEdit: false,
      isShowUpdate: false,
      isShowHistoryVersion: false,
      savedInDisabled: false,
      className: "supportingModalFiles",
      ref: supportingModalRef,
      fileTableRef: supportingFileModalTableRef,
      pageType: this.props.pageType,
      title: "",
      hintMsg: "",
      inModal: true,
      procedureId: this.props.procedureId,
      procedureTaskId: this.props.procedureTaskId,
      isSupportingSection: false,
      supportingPendingProcessId: this.state.supportingPendingProcessId,
    });
  };

  openSupportingfileCreateModal = () => {
    this.setState({
      isScrollModalOpen: true,
      isSupportingFileEditToolTipOpen: false,
      scrollModalContent: (
        <ProcedureBlock
          child={this.handleReturnModalSupportingFileTable(true, false)}
          isShowArrow={false}
          className="processProcedureModalBlock supportingFileModalBlock"
          isOpen={true}
        />
      ),
      scrollModalTitle: <HeaderWithReminder>Supporting Files</HeaderWithReminder>,
      handleModalConfirm: () => {
        //there is a empty function
      },
      handleModalCancel: () => {
        //there is a empty function
      },
    });
  };

  /**
   * function about edit check callback unlock
   */
  handleSupportingFileUnlock = () => {
    // @ts-ignore
    this.createFiles("modal", this.openSupportingfileCreateModal);
  };

  openSupportingfileUpdateModal = () => {
    this.setState({
      isScrollModalOpen: true,
      isSupportingFileEditToolTipOpen: false,
      scrollModalContent: (
        <ProcedureBlock
          child={this.handleReturnModalSupportingFileTable(false, false)}
          isShowArrow={false}
          className="processProcedureModalBlock supportingFileModalBlock"
          isOpen={true}
        />
      ),
      scrollModalTitle: <HeaderWithReminder>Supporting Files</HeaderWithReminder>,
      handleModalConfirm: () => {
        //there is a empty function
      },
      handleModalCancel: () => {
        //there is a empty function
      },
    });
  };

  /**
   * function about edit check callback unlock
   */
  handleUpdateSupportingFileUnlock = () => {
    // @ts-ignore
    this.createFiles("modal", this.openSupportingfileUpdateModal);
  };

  /**
   * function about check whether supporting file section is locked when click edit icon
   * @param {*} isLock
   * @param {*} lockUser
   */
  checkSupportingFileWhetherLock = (isLock: any, lockUser: any) => {
    if (isLock) {
      this.props.setLock(`${lockUser} is editing this section.`);
      this.handleSupportingFileLock();
    } else {
      this.props.setActionType(this.props.actionType);
      this.props.setLock("");
      this.state.status === 3
        ? this.handleUpdateSupportingFileUnlock()
        : this.handleSupportingFileUnlock();
    }
  };

  createLine = (dataList: any, fileId: any, fileName: any) => {
    const lineId = this._generateGUID();
    const fileKey = this._generateGUID();
    if (this.state.status === 3) {
      dataList.unshift({
        data: [
          { name: "lineId", value: lineId },
          { name: "fileId", value: fileId },
          { name: "fileKey", value: fileKey },
          {
            name: "fileName",
            value: fileName,
            tagValue: fileTags.new,
          },
          {
            name: "uploadedDate",
            value: this._formateDate(getTimeZoneString(this._getDate())),
          },
          {
            name: "uploadByName",
            // @ts-ignore
            value: this.user.identityUserInfo.englishName,
          },
          {
            name: "uploadBy",
            // @ts-ignore
            value: this.user.identityUserInfo.internalUserID,
          },
          {
            name: "proposedChange",
            value: proposedChangeTags.new,
          },
          { name: "note", value: "" },
          { name: "approveDate", value: null },
          { name: "approveTime", value: null },
          { name: "fileOperate", value: 1 },
        ],
        checked: false,
      });
    } else {
      dataList.unshift({
        data: [
          { name: "lineId", value: lineId },
          { name: "fileId", value: fileId },
          { name: "fileKey", value: fileKey },
          {
            name: "fileName",
            value: fileName,
          },
          {
            name: "uploadedDate",
            value: this._formateDate(getTimeZoneString(this._getDate())),
          },
          {
            name: "uploadByName",
            // @ts-ignore
            value: this.user.identityUserInfo.englishName,
          },
          {
            name: "uploadBy",
            // @ts-ignore
            value: this.user.identityUserInfo.internalUserID,
          },
          { name: "note", value: "" },
          { name: "approveDate", value: null },
          { name: "fileOperate", value: 1 },
        ],
        checked: false,
      });
    }
  };

  /**
   * success callback for upload file
   * @param {*} result
   * @param {*} returnPara
   * @param {*} ref
   */
  // @ts-ignore
  uploadFileOnSuccess = (result: any, returnPara: any, ref: any) => {
    const fileId = result.storageFileID;
    handleUploadErrorCode(result.errorCode);
    const supportingFileData = ref.current.getDataList();
    this.createLine(supportingFileData, fileId, returnPara.fileName);
    this.handleUploadLoading("supporting");
    ref.current.updateDataList(supportingFileData);
    // @ts-ignore
    if (returnPara.fileIndex < this.fileList.length - 1) {
      this.uploadFile(returnPara.fileIndex + 1, ref);
    }
  };

  /* function about upload depulicate file when upload file */
  handleReplaceFile = (event: any, ref: any) => {
    // @ts-ignore
    this.fileList = [...event.target.files];
    // @ts-ignore
    this.procedureFileNum = this.fileList.length;
    // @ts-ignore
    if (handleAlertUploadFileError(this.fileList)) {
      return;
    }
    const tableDataList = ref.current.getDataList();
    let dataList: any[] = [];
    tableDataList.forEach((data: any) => {
      const item = data.data.find((dataItem: any) => dataItem.name === "fileName");
      dataList.push(item);
    });

    if (this.state.status === 3) {
      this.updateFileProcess(0, dataList, tableDataList, ref);
    } else {
      this.FileProcess(0, dataList, tableDataList, ref);
    }
  };

  /**
   * funtion about return supporting file section
   * @param {*} obj
   * @returns
   */
  handleReturnSupportingFileTable = (obj: any) => {
    const {
      supportingSubmited,
      supportingSaved,
      isShowUploadBtn,
      isShowDeleteBtn,
      isShowDownloadBtn,
      isShowShareBtn,
      isShowActionBtns,
      isShowSupportingFileEdit,
      isShowUpdate,
      isShowHistoryVersion,
      className,
      noteDisabled,
      ref,
      fileTableRef,
      pageType,
      title,
      hintMsg,
      inModal,
      isSupportingSection,
    } = obj;
    const componentProps = {
      fileInputRef: supportingFileRef,
      fileTableRef: fileTableRef,
      title: title,
      handleFileSelect: (e: any) => this.handleReplaceFile(e, ref),
      onSave: () => this.supportingFileOnSave(ref),
      onSubmit: () => this.supportingFileOnSubmit(ref),
      onCancel: () => this.supportingFileOnCancel(ref),
      hasSubmit: supportingSubmited,
      hasSave: supportingSaved,
      isScrollData: true,
      className: className,
      isShowExpendIcon: true,
      isShowUploadBtn: isShowUploadBtn,
      isShowDeleteBtn: isShowDeleteBtn,
      isShowDownloadBtn: isShowDownloadBtn,
      isShowShareBtn: isShowShareBtn,
      isShowActionBtns: isShowActionBtns,
      isShowSupportingFileEdit: isShowSupportingFileEdit,
      isShowUpdate: isShowUpdate,
      isShowHistoryVersion: isShowHistoryVersion,
      hintMsg: hintMsg,
      isEditToolTipOpen: this.state.isSupportingFileEditToolTipOpen,
      handleEditClick: () => this.handleSupportingFileEditClick(),
      onBlur: () => this.setScrollModalOpen(false),
      noteDisabled: noteDisabled,
      pageType: pageType,
      status: this.state.status,
      initProcedureDataList: this.state.initSupportingDataList,
      procedureMandatoryCheck: () => this.procedureMandatoryCheck(ref),
      _showLoading: this.props.showLoading,
      _hideLoading: this.props.hideLoading,
      inModal: inModal,
      taskInformationData: this.props.taskInformationData,
      procedureId: this.props.procedureId,
      procedureTaskId: this.props.procedureTaskId,
      isSupportingSection: isSupportingSection,
      supportingPendingProcessId: this.state.supportingPendingProcessId,
      isProcedureDetailSection: true,
    };
    return this.state.status === 3 ? (
      <UpdateSupportingFileManagement ref={ref} {...componentProps} />
    ) : (
      <BaseSupportingFileManagement ref={ref} {...componentProps} />
    );
  };

  updateModalWidth = () => {
    if (!this.state.isScrollModalOpen) return;
    this.setState({
      ...this.state,
    });
  };

  componentDidMount() {
    this.updateModalWidth();
    window.addEventListener("resize", this.updateModalWidth);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateModalWidth);
  }

  render() {
    const { isShowTable, pageType } = this.props;
    // @ts-ignore
    const modalWidth =
      document.getElementsByClassName("procedureBlock")[0] !== undefined &&
      document.getElementsByClassName("procedureBlock")[0].offsetWidth;
    return (
      <>
        <ProcedureBlock
          child={
            isShowTable &&
            this.state.isMount &&
            this.handleReturnSupportingFileTable({
              supportingSubmited: this.state.supportingSubmited,
              supportingSaved: this.state.supportingSaved,
              isShowUploadBtn: false,
              isShowDeleteBtn: false,
              isShowDownloadBtn: true,
              isShowShareBtn: true,
              isShowActionBtns: false,
              isShowSupportingFileEdit: this.props.isShowSupportingFileEdit,
              isShowUpdate: false,
              isShowHistoryVersion: true,
              className: "supportingFiles",
              noteDisabled: true,
              ref: ref,
              fileTableRef: supportingFileTableRef,
              pageType: pageType,
              title: "Supporting Files",
              hintMsg: this.props.hintMsg,
              inModal: false,
              isSupportingSection: true,
              supportingPendingProcessId: this.state.supportingPendingProcessId,
            })
          }
          isShowArrow={false}
          className="processProcedureBlock supportingFileBlock"
          isOpen={true}
        />
        <NormalModal
          testid="supporting-file-modal"
          okText={this.state.modalOkText}
          cancelText={this.state.modalCancelText}
          childContent={<p className="fs-16">{this.state.modalChildContent}</p>}
          isModalOpen={this.state.isModalOpen}
          handleOk={this.state.handleModalConfirm}
          handleCancel={() => {
            this.state.handleModalCancel();
            this.hideModal();
          }}
          closable={false}
          okButtonTestid="supporting-file-modal-ok-btn"
          cancelButtonTestid="supporting-file-modal-cancel-btn"
        />
        <ModalWithScroll
          testid="supporting-file-scroll-modal"
          isModalOpen={this.state.isScrollModalOpen}
          modalContent={this.state.scrollModalContent}
          title={this.state.scrollModalTitle}
          handleCloseClick={() => {
            this.hideScrollModal();
            this.handleResetLockWithoutRefresh("SupportingFile");
            this.props.setActionType(null);
          }}
          width={modalWidth}
          actionType={this.props.actionType}
        />
      </>
    );
  }
}
